module.exports = __webpack_public_path__ + "img/switzerland.fda09c52.svg";